<template>
  <Modal v-model="visible" width="1300px" title="新增业务员" :footer-hide="true" :mask-closable="false" class="train-add-user my-modal p-b">
    <div class="top-box">
      <Input v-model="searchParams.nameOrNo" placeholder="请输入员工名称或工号" search @on-search="searchAjax()" />
      <RadioGroup v-model="searchParams.businessStatus" class="status" @on-change="searchAjax()">
        <Radio label="">
          <span>全部</span>
        </Radio>
        <Radio label="1">
          <span>在职</span>
        </Radio>
        <Radio label="2">
          <span>停职</span>
        </Radio>
        <Radio label="3">
          <span>离职</span>
        </Radio>
      </RadioGroup>
      <Button type="primary" @click="submit" class="btn">确定</Button>
    </div>
    <orgTree @change="selectNode" isSelect="1" ref="treeBox" :isAll="true" :multiple="false"></orgTree>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange" :maxHeight="tableH">
        <template slot-scope="{ row }" slot="name">
          <div class="user-box" v-if="row.name">
            <i class="dian" :class="{ 'red': row.businessStatus == 3, 'orange': row.businessStatus == 2 }"></i>
            <span class="user-name">{{ row.name }}</span>
          </div>
        </template>
        <template slot-scope="{ row }" slot="action">
          <div class="detail">
            <div @click="del(row)">
              <span>删除</span>
            </div>
          </div>
        </template>
      </Table>
    </div>
  </Modal>
</template>

<script>
import orgTree from '@/components/commons/orgTree/orgTree';
import { pageTool } from '@/api/mixins';
export default {
  components: {
    orgTree
  },
  mixins: [pageTool],
  data() {
    return {
      visible: false,
      loading: false,
      formData: {},
      tableH: document.body.clientHeight - 260,
      selectArr: [],
      columns: [
        {
          type: 'selection',
          width: 50,
          align: 'center'
        },
        {
          title: '工号',
          key: 'staffNo',
          align: 'center'
        },
        {
          title: '姓名',
          slot: 'name',
          align: 'center'
        },
        {
          title: '所属机构',
          key: 'orgName',
          align: 'center'
        },
        {
          title: '所属团队',
          key: 'groupName',
          align: 'center'
        }
      ]
    };
  },
  created() {
    window.addEventListener('resize', () => {
      this.tableH = document.body.clientHeight - 260;
    });
  },
  methods: {
    open(data = {}) {
      this.formData.businessId = data.id;
      this.searchParams.businessId = data.id;
      this.searchParams.selected = false;
      this.visible = true;
      this.listUrl = '/buz/merchantActivity/queryJoinUserList';
      this.pageNum = 1;
      this.pageSize = 999;
      this.getList();
      this.$refs.treeBox.init('', { source: '2' });
    },

    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.id); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.id); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.id) && !selectIds.includes(item.id)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.id);
        } else if (!ids.includes(item.id) && selectIds.includes(item.id)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.id), 1);
          selectIds.splice(selectIds.indexOf(item.id), 1);
        }
      });
    },

    // 选择组织
    selectNode(cur) {
      this.searchParams.nameOrNo = '';
      if (cur.nodeType === 1) {
        //机构
        this.searchParams.orgId = cur.id;
        this.searchParams.groupId = '';
      } else {
        this.searchParams.orgId = '';
        this.searchParams.groupId = cur.id;
      }
      if (!this.visible) {
        //不显示时不处理
        return;
      }
      this.searchAjax();
    },

    listCallback(res) {},

    submit() {
      if (this.loading) {
        return;
      }
      this.formData.dateList = this.selectArr.map(item => item.id);
      if (!this.formData.dateList.length) {
        this.$notice.msg('请选择需要添加的业务员');
        return;
      }
      this.listLoading = true;
      this.$http({
        type: 'POST',
        url: '/buz/merchantActivity/saveJoinUserList',
        data: this.formData
      })
        .then(res => {
          this.$emit('success');
          this.$notice.success('操作成功');
          this.visible = false;
          this.selectArr = [];
        })
        .catch(res => {
          this.listLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.train-add-user /deep/ {
  .ivu-modal {
    top: 5vh;
  }
  .ivu-modal-body {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    .top-box {
      width: 100%;
      display: flex;
      margin-top: 10px;
      .ivu-input-wrapper {
        width: 300px;
      }
      .status {
        margin-left: 20px;
        margin-top: 5px;
      }
      .btn {
        margin-left: auto;
      }
    }
    .org-tree-panel {
      padding: 0;
      height: calc(90vh - 160px);
      margin-top: 10px;
    }
    .table-box {
      width: calc(100% - 320px);

      margin-top: 10px;
      .ivu-table-body {
        &:before {
          content: '';
          position: absolute;
          background-color: #dcdee2;
          width: 100%;
          height: 1px;
          left: 0;
          bottom: 0;
          z-index: 4;
        }
        &::-webkit-scrollbar-track {
          border-right: 1px solid #e9e9e9;
          border-left: 1px solid #e9e9e9;
          border-bottom: 1px solid #e9e9e9;
        }
      }
    }
  }
}
/deep/ .user-box {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  height: 22px;
  .dian {
    display: block;
    width: 5px;
    height: 5px;
    background: #35bf3f;
    border-radius: 50%;
    margin-right: 4px;
    &.red {
      background: #e3461f;
    }
  }
  &.text {
    color: #515c6f;
  }
  .user-name {
    font-size: 13px;
  }
  i {
    color: #bababa;
    font-size: 13px;
  }
}
</style>
